import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/sources/…` → `/{store}/sources/…`. */
export const Route = createFileRoute("/sources/$")({ beforeLoad: redirectIntoScope });
